<!-- 
  新建访客计划 特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="workReport">
    <!-- 批阅人 -->
    <template v-if="item.attr === 'approvedPeople'">
      <el-input v-model="item.attrValue" :disabled="true"></el-input>
    </template>
    <!-- 抄送人 -->
    <template v-else-if="item.attr === 'cc'">
      <el-select
        v-model="item.attrValue"
        filterable
        multiple
        placeholder="请选择抄送人"
        :multiple-limit="20"
        size="small"
        style="width: 100%;">
        <el-option v-for="user in mUserList" :label="user.name" :value="user.userId" :key="user.userId">
        </el-option>
      </el-select>
    </template>
    <!-- 今日计划 -->
    <template v-else-if="item.attr === 'thisPlan'">
      <div v-if="item.attrValue.length===0">
        无
      </div>
      <div class="todayPlan" v-for="plan in formatStatus(item.attrValue)">
        <el-switch
          v-model="plan.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="已完"
          inactive-text="未完">
        </el-switch>
        <p class="text" style="margin-left:10px">{{plan.content}}</p>
      </div>
    </template>
    <!-- 业绩数据 -->
    <template v-if="item.attr === 'thisStatistic'">
      <div class="workData">
        {{formatStatistic(item.attrValue)}}
      </div>
    </template>
    <!-- 明日计划 -->
    <template v-if="item.attr === 'nextPlan'">
      <el-input
        placeholder="请输入计划"
        v-for="(plan, index) in formatNextPlan(item.attrValue)" v-model="plan.content" class="v-input" :key="index"
        style="margin-bottom:10px">
          <el-button @click="addTel(item.attrValue)" slot="append" v-if="index === 0" icon="el-icon-plus"></el-button>
          <el-button @click="delTel(index, item.attrValue)" slot="append" v-if="index !== 0" icon="el-icon-minus"></el-button>
      </el-input>
    </template>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import { mapActions } from 'vuex'

export default {
  props: ['item', 'form'],
  data () {
    return {
      mUserList: []
    }
  },
  created () {
    if (this.item.attr === 'cc') {
      this.loadUserList()
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    formatStatus (Arr) {
      for (let i = 0; i < Arr.length; i++) {
        if (typeof Arr[i].status !== 'boolean') {
          Arr[i].status = Arr[i].status === 1
        }
      }
      return Arr
    },
    formatNextPlan (Arr) {
      if (Arr.length === 0) {
        Arr.push({
          content: '',
          status: false
        })
      }
      return Arr
    },
    formatStatistic (object) {
      let string = ''
      for (let item in object) {
        switch (item) {
          case 'customerAddCount':
            string += '客户（' + this.formatIntStatisticContent(object[item]) + ' ）个;'
            break
          case 'communicateAddCount':
            string += '跟进记录（' + this.formatIntStatisticContent(object[item]) + '）次;'
            break
          case 'opportunityAddCount':
            string += '机会（' + this.formatIntStatisticContent(object[item]) + '）个;'
            break
          case 'oppAmount':
            string += '机会金额（' + this.formatStatisticContent(object[item]) + '）元;'
            break
          case 'contractAddCount':
            string += '合同（' + this.formatIntStatisticContent(object[item]) + '）份;'
            break
          case 'contractAmount':
            string += '合同金额（' + this.formatStatisticContent(object[item]) + '）元;'
            break
          case 'paymentSheetAmount':
            string += '回款金额（' + this.formatStatisticContent(object[item]) + ') 元;'
            break
        }
      }
      if (string) {
        return string
      } else {
        return '无'
      }
    },
    formatIntStatisticContent (value) {
      if (value !== 'undefined' && !isNaN(value) && value) {
        return parseInt(value)
      }
      return '0'
    },
    formatStatisticContent (value) {
      if (value !== 'undefined' && !isNaN(value) && value) {
        return parseFloat(value)
      }
      return '0.00'
    },
    loadUserList () {
      let url = `/customer/public/userListAjax.do.html`
      api.post(url, {}, (data) => {
        this.mUserList = data.userList
      })
    },
    // 增加明日计划
    addTel (arr) {
      if (arr.length < 20) {
        arr.push({
          content: '',
          status: 0
        })
      } else {
        Message('计划最多只能建20条哦')
      }
    },
    delTel (index, arr) {
      arr.splice(index, 1)
    }
  },
  components: {
  }
}
</script>

<style lang="less" scoped>
.workReport {
  .todayPlan {
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?29b1bfea